import React, { useState } from "react";
import axios from "axios";
import { createLead } from "../axios/api";

const useContactForm = (type, recaptcha) => {
  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState("");

  const onSubmit = async (values, { resetForm }) => {
    const token = await recaptcha.current.executeAsync();

    const url =
      process.env.NODE_ENV === "production"
        ? "/scripts/grecaptcha.php"
        : "http://dev.pedders.eu/scripts/grecaptcha.php";
    const formUrl =
      process.env.NODE_ENV === "production"
        ? "/scripts/submitForm.php"
        : "http://dev.pedders.eu/scripts/submitForm.php";
    const data = new FormData();
    data.append("token", token);

    try {
      const grecaptcha = await axios({
        method: "POST",
        url,
        data,
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (grecaptcha.data.success) {
      } else {
        throw "Google Recaptcha error. Please try again later";
      }
      if (type === "DEALER") {
        await createLead(values);
      }
      const formData = new FormData();
      for (const value in values) {
        formData.append(value, values[value]);
      }
      formData.append("type", type);
      const sendResponse = await axios({
        method: "POST",
        data: formData,
        url: formUrl,
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (sendResponse.data === "OK") {
        setModalText(
          "Contact Form Submitted. We endeavour to respond within 48 hours"
        );
      } else {
        throw "Server error. Please try again later";
      }
    } catch (error) {
      setModalText(error);
    } finally {
      setShowModal(true);
      resetForm();
    }
  };

  return {
    modalText,
    setShowModal,
    showModal,
    onSubmit,
  };
};

export default useContactForm;
